<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <Toast />
        <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-1">
              <div class="col-12 section_title">PRESUPUESTO NRO. {{ form.document_number }}</div>
            </div>
          </template>

          <template v-slot:end>
            <Button
              label="REGRESAR"
              icon="pi pi-arrow-left"
              class="p-button p-component p-button-text mr-2"
              @click="goBack()"
            />
            
          </template>
        </Toolbar>

        <div class="">
          <div class="">
            <div class="formgrid grid">
              <div class="field col-2">
                <label for="name">FECHA</label>
                <span id="detail" type="text" class="inputfield w-full">
                  <h4>{{ formatDate(form.date_at) }}</h4>
                </span>
              </div>

              <div class="field col-4">
                <label for="name">CLIENTE</label>
                <span id="detail" type="text" class="inputfield w-full">
                  <h4>{{ form.cliente?.code }}</h4>
                </span>
              </div>

              <div class="field col-3">
                <label for="name">PLAZO DE ENTREGA</label>
                <span id="detail" type="text" class="inputfield w-full">
                  <h4>{{ form.delivery_term }} Dias</h4>
                </span>
              </div>

              <div class="field col-3">
                <label for="name">DIAS DE MANTENIMIENTO DE OFERTA</label>
                <span id="detail" type="text" class="inputfield w-full">
                  <h4>{{ form.offer_days }}</h4>
                </span>
              </div>

            </div>
          </div>

          
        </div>
      </div>
    </div>
    <div class="col-12">
            
      <div class="card">
        <div class="my-1">
          <div class="col-12 section_subtitle">Productos</div>
        </div>

        <div class="">
          <DataTable
            :value="items"
             dataKey="id" 
            class="p-datatable-sm"
            responsiveLayout="scroll"
          >

           <Column headerClass="" field="cantidad" header="Cantidad" headerStyle="max-width: 20%">
              <template #body="slotProps">
                {{ slotProps.data.cantidad }}
              </template>
            </Column>
            <Column field="name" header="Descripción"></Column>
            <Column field="costo" header="Pr. Unitario"></Column>
             <Column field="descuento" header="% Desc."></Column> 
            <Column header="Importe">
                <template #body="slotProps">
                    <div class="flex justify-content-between">
                      <div>
                        <span>{{toUsd(slotProps.data.importe)}}</span>
                      </div>
                      <!--
                      <div>
                        <span>{{toArs(slotProps.data.importe)}}</span>
                      </div>
                      -->
                    </div>
                
                </template>
            ></Column>
          </DataTable>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CrudService from "./../../services/crud.service.js";

export default {
  data() {
    return {
      routeName: null,
      form: {
        document_number: '00000000',
        tipo: 0,
        cliente: null,
        date_at: new Date(),
        delivery_term: '',
        terms_of_sale: '',
        offer_days: '',
        items: [],
      },
      mod: [],
      items: [],

      actualFormula: "",
      costo: 0,
      cantidad: 1,
      descuento: 0,
      products: null,
      filteredProducts: null,
      newItem: null,
      selectedProduct: null,

      clientes: null,
      mods: null,
      newItemMOD: null,
      filteredMod: null,
      selectedMod : null,
      actualFormulaMOD: "",

      submitted: false,
      validationErrors: null,


      dolarValue: 0,
      ciif: 0.17,
      mpi: 0.17,
      moi: 0.24,
      tipos: [
        { value: 0, label: "Contado" },
        { value: 1, label: "Crédito" }
      ],
      calidades: [
        { value: 0, label: "G2" },        
      ],
      materials: [],
    };
  },
  computed: { },
  created() {
    this.routeName = this.$route.name;
  },
  mounted() { 
    CrudService.getCRUD("presupuestos",  this.$route.params.id).then((data) => {
      this.form = { ...data };
      this.form.tipo = data.type_id
      if (data.detalle) {
        data.detalle.forEach((item) => {
          console.log('item')
          console.log(item)
          let name = item.producto.name ? item.producto.name : '';
          this.items.push({
            id: item.id,
            name: name,
            description: name,
            costo: item.price,
            descuento: item.discount,
            cantidad: item.quantity,
            importe: item.total
          });
          console.log('this.items')
          console.log(this.items)
        });
      }      
    });
    CrudService.getCRUD("cliente", "cliente").then((data) => (this.clientes = data));
    CrudService.getCRUD("productos").then((data) => (this.products = data));
    CrudService.getCRUD("configuraciones").then(response => {
        this.dolarValue = response.dolarvalue; 
        this.ciif = response.ciif; 
        this.mpi = response.mpi; 
        this.moi = response.moi; 
    });
  },
  methods: {
    formatDate(date_at) {
      let date, month, year;
      let new_date = new Date(date_at);
      date = new_date.getDate() +1;
      month = new_date.getMonth() + 1;
      year = new_date.getFullYear();

        date = date
            .toString()
            .padStart(2, '0');

        month = month
            .toString()
            .padStart(2, '0');

      return `${date}/${month}/${year}`;
    },
    selectProduct() {
      this.newItem = this.selectedProduct;
      let prod = this.products.filter((item) => item.id==this.newItem.id);
      this.costo = 1;
      if (prod.length){
        this.costo = prod[0].costo;
      }
    },
    toArs(value) {
      let calc = value * this.dolarValue;    
      return calc.toLocaleString("es-AR", {
        style: "currency",
        currency: "ARS",
      });
    },
    toUsd(value) {
      return value.toLocaleString("es-AR", {
        style: "currency",
        currency: "USD",
      });
    },
    delItem(itemId){
      let index = this.items.findIndex(item => item.id == itemId);
      this.items.splice(index, 1);
    },
    delItemMOD(itemId){
      console.log(itemId)
      let index = this.mod.findIndex(item => item.id == itemId);
      this.mod.splice(index, 1);
    },
    displayErrors(errors) {
      for (let key in errors) {
        this.validationErrors.push({ field: key, message: errors[key] });

        let error = errors[key];
        this.$toast.add({
          severity: "error",
          summary: "Error!",
          detail: error[0],
          life: 3000,
        });
      }
    },
    searchProduct(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredProducts = [...this.products];
        } else {
          this.filteredProducts = this.products.filter((prod) => {
            return prod.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      }, 250);
    },
    searchMDO(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredMod = [...this.clientes];
        } else {
          this.filteredMod = this.clientes.filter((prod) => {
            return prod.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      }, 250);
    },
    addItem() {
      if (this.newItem) {
        let descuento = (this.newItem.costo*this.cantidad) * this.descuento / 100;
        let importe = (this.newItem.costo*this.cantidad) - descuento;
        this.items.push({
          id: this.newItem.id,
          name: this.newItem.name,
          description: this.newItem.description,
          costo: this.newItem.costo,
          descuento: descuento,
          cantidad: this.cantidad,
          importe: importe,
        });
        this.actualFormula = null;
        this.newItem = null;
        this.selectedProduct = null;
      }
    },
    goBack() {
      this.$router.push("/presupuestos");
    },
    save() {
      this.submitted = true;
      this.form.cliente_id = this.form.cliente.id;
      this.form.items = this.items;

      CrudService.updateCRUD("presupuestos", "presupuestos", this.form).then(
        (data) => {
          this.validationErrors = [];
          if (data.status == 400) {
            this.displayErrors(data.data);
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Éxito!",
              detail: "Actualizado correctamente.",
              life: 3000,
            });

            this.$router.push("/presupuestos");
          }
        }
      );
    },
  },
};
</script>


<style scoped>

  .section_subtitle {
    font-size: 1.2rem;
    font-weight: bold;
    color: #1261b1;
    margin-bottom: 1rem;
  }

  .card {
    padding-top: 0.25rem;
  }

</style>